import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Input, InputGroup, FormGroup, Form, Row, Col, Table } from 'reactstrap';
import { Translate, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IThuVien } from 'app/shared/model/thu-vien.model';
import { searchEntities, getEntities } from './thu-vien.reducer';

export const ThuVien = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [search, setSearch] = useState('');

  const thuVienList = useAppSelector(state => state.thuVien.entities);
  const loading = useAppSelector(state => state.thuVien.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const startSearching = e => {
    if (search) {
      dispatch(searchEntities({ query: search }));
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="thu-vien-heading" data-cy="ThuVienHeading">
        <Translate contentKey="xtdtApp.thuVien.home.title">Thu Viens</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="xtdtApp.thuVien.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/thu-vien/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="xtdtApp.thuVien.home.createLabel">Create new Thu Vien</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('xtdtApp.thuVien.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {thuVienList && thuVienList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="xtdtApp.thuVien.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.thuVien.tieuDe">Tieu De</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.thuVien.loaiThuVien">Loai Thu Vien</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.thuVien.link">Link</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.thuVien.hienThiTrangChu">Hien Thi Trang Chu</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.thuVien.thuTuUuTien">Thu Tu Uu Tien</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {thuVienList.map((thuVien, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/thu-vien/${thuVien.id}`} color="link" size="sm">
                      {thuVien.id}
                    </Button>
                  </td>
                  <td>{thuVien.tieuDe}</td>
                  <td>
                    <Translate contentKey={`xtdtApp.LoaiThuVienEnum.${thuVien.loaiThuVien}`} />
                  </td>
                  <td>{thuVien.link}</td>
                  <td>{thuVien.hienThiTrangChu ? 'true' : 'false'}</td>
                  <td>{thuVien.thuTuUuTien}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/thu-vien/${thuVien.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`/thu-vien/${thuVien.id}/edit`} color="primary" size="sm" data-cy="entityEditButton">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`/thu-vien/${thuVien.id}/delete`} color="danger" size="sm" data-cy="entityDeleteButton">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="xtdtApp.thuVien.home.notFound">No Thu Viens found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ThuVien;
